import { z } from 'zod/v4';

export const RemoveDemoParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type RemoveDemoParams = z.infer<typeof RemoveDemoParamsSchema>;
